import { render, staticRenderFns } from "./SLAPopoverCard.vue?vue&type=template&id=ae105d0c&"
import script from "./SLAPopoverCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./SLAPopoverCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports